"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var index_exports = {};
__export(index_exports, {
  Analytics: () => Analytics
});
module.exports = __toCommonJS(index_exports);

// src/analytics-core.ts
var Analytics = class {
  constructor(writers, scope, sourceApp) {
    this.writers = writers;
    this.scope = scope;
    this.sourceApp = sourceApp;
  }
  async identify(userId, traits) {
    const data = traits ?? {};
    await Promise.all(
      this.writers.map(async (plugin) => await plugin.identify(userId, data))
    );
  }
  async track(eventName, payload) {
    const mappedPayload = {
      ...payload,
      MetaData: {
        ...payload.MetaData || {},
        sendToOpenSearch: !payload.MetaData?.SkipMixpanel
      }
    };
    await Promise.all(
      this.writers.map(
        async (writer) => await writer.track(eventName, mappedPayload)
      )
    );
  }
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Analytics
});
